import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { NAV_LINKS, tint } from "@/data/site";
import { Container } from "@/components/shared/Primitives";
import { RadarRings } from "@/components/shared/Decorations";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!ok) {
      toast.error("Enter a valid email address");
      return;
    }
    // TODO: Wire to Beehiiv API when ESP is connected
    setDone(true);
    setEmail("");
    toast.success("You're on the list — we'll be in touch.");
    setTimeout(() => setDone(false), 2600);
  };

  return (
    <footer className="relative mt-10 overflow-hidden" style={{ background: "var(--footer-bg)", borderTop: "1px solid var(--stroke-0)" }}>
      <RadarRings className="pointer-events-none absolute -right-40 -top-48 h-[520px] w-[520px] opacity-50" />
      <Container className="relative z-10 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.6fr_1fr_1.4fr]">
          <div>
            <img src="/logo-dark.png" alt="Emailink" className="h-10 w-auto" />
            <p className="mt-5 max-w-xs text-[14px] leading-relaxed" style={{ color: "var(--text-2)" }}>
              A multi-disciplinary studio. A retention agency, a set of apps, and a lab for the experiments in between.
            </p>
          </div>

          <div>
            <p className="font-tech mb-4 text-[10px] uppercase tracking-[0.18em]" style={{ color: "var(--text-3)" }}>Studio</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-[14px] transition-colors hover:text-[color:var(--text-0)]" style={{ color: "var(--text-2)" }}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-tech mb-4 text-[10px] uppercase tracking-[0.18em]" style={{ color: "var(--text-3)" }}>Newsletter</p>
            <p className="mb-4 text-[13px] leading-relaxed" style={{ color: "var(--text-2)" }}>
              Occasional notes on retention, products and experiments. No spam.
            </p>
            <form onSubmit={submit} className="flex items-center gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@brand.com"
                data-testid="newsletter-email-input"
                className="h-11 w-full rounded-[10px] px-3 text-[13px] outline-none transition-colors"
                style={{ background: "var(--surface-0)", border: "1px solid var(--stroke-1)", color: "var(--text-0)" }}
              />
              <button
                type="submit"
                data-testid="newsletter-submit-button"
                aria-label="Subscribe"
                className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-[10px] transition-transform active:scale-95"
                style={{ background: "var(--page-accent)", color: "var(--on-accent)" }}
              >
                {done ? <Check className="h-4 w-4" /> : <ArrowRight className="h-4 w-4" />}
              </button>
            </form>
            <p className="mt-4 text-[13px]" style={{ color: "var(--text-3)" }}>
              Contact:{" "}
              <a href="mailto:jordan@emailink.io" className="transition-colors hover:text-[color:var(--text-1)]" style={{ color: "var(--text-2)" }}>
                jordan@emailink.io
              </a>
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t pt-6 sm:flex-row sm:items-center" style={{ borderColor: "var(--stroke-0)" }}>
          <span className="text-[12px]" style={{ color: "var(--text-3)" }}>© {new Date().getFullYear()} Emailink Studio. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-[12px] transition-colors hover:text-[color:var(--text-1)]" style={{ color: "var(--text-3)" }}>Privacy</Link>
            <Link to="/terms" className="text-[12px] transition-colors hover:text-[color:var(--text-1)]" style={{ color: "var(--text-3)" }}>Terms</Link>
            <Link to="/contact" className="text-[12px] transition-colors hover:text-[color:var(--text-1)]" style={{ color: "var(--text-3)" }}>Contact</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
};
